export default "__VITE_ASSET__DsefDgaJ__"